import React from 'react';
import ReactDOM from 'react-dom/client';
// JetBrains Mono self-hosted (landing code blocks) — no external font CDN
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/600.css';
import './index.css';
import App from './App';
import { captureConnectorIntent } from './connectorIntent';
import '@ant-design/v5-patch-for-react-19';
import './wdyr'; // <--- first import
import './dev/consoleBridge'; // dev-only: forward console logs to terminal

// PostHog Analytics
import posthog from 'posthog-js';
import { PostHogProvider, PostHogErrorBoundary } from '@posthog/react';

// Before anything routes: a connector hands off through the query string, and
// an unauthenticated visitor is redirected to sign in before the account
// screen ever mounts, so reading it there loses it. It has to be read here
// and parked. (Below the imports, not among them — ES imports hoist, so the
// position makes no difference to when this runs, and import/first fails the
// build over it.)
captureConnectorIntent();

// Initialize PostHog
posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  defaults: '2025-11-30',
  capture_pageview: true,
  capture_pageleave: true,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <PostHogProvider client={posthog}>
    <PostHogErrorBoundary>
      <App />
    </PostHogErrorBoundary>
  </PostHogProvider>
  // </React.StrictMode>
);
